import { type TGenericStoreState } from '../../redux';

type TNestedBoolOrObject<T> = {
  [SliceKey in keyof T]?: { [FieldName in keyof T[SliceKey]]?: true };
};

/**
 * Поля в store, которые могут быть залогированы в случае ошибки.
 * Избегайте добавления полей с конфиденциальными данными или массивами.
 */
const loggableFieldsInStore: TNestedBoolOrObject<TGenericStoreState<'subsidizedCalculator'>> = {};

/**
 * Функция, извлекающая значения полей из store для передачи в логгер.
 */
export function extractStoreStateForRequestLog(state: unknown): string {
  if (!state || typeof state !== 'object') {
    return JSON.stringify({});
  }

  const reduxStateToLog: Record<string, unknown> = {};

  for (const [sliceKey, sliceValue] of Object.entries(loggableFieldsInStore)) {
    for (const fieldName of Object.keys(sliceValue)) {
      if (sliceKey in state && typeof state[sliceKey as keyof unknown] === 'object') {
        reduxStateToLog[fieldName] = state[sliceKey as keyof unknown][fieldName as keyof unknown];
      }
    }
  }

  return JSON.stringify(reduxStateToLog);
}
